<template>
    <div>
        <li class="nav-item" @mouseover="expandMouse(route,true)"  @mouseout="expandMouse(route,false)" :class="`tree${treeStage} route${route.expand}`" :key="route.title" >

            <router-link v-if="LayoutType == 'mini-sidebar' ? !route.header : true"  :to="`${route.to || ''}`" > <!--  -->
                <span  @click="expand(route)" :class="`nav-link d-flex ${(route.header ? 'nav-small-cap nav-header' : '')} collapsed ${route.to && !route.children && !route.icon ? 'sem-icon' : ''} menu-border`">
                    <i :class="route.icon + ' icon-route'" v-if="!route.materialIcon"></i>
                    <i class="material-icons icon-route" v-if="route.materialIcon">{{route.icon}}</i>
                    <span :class="(LayoutType == 'mini-sidebar'? treeStage == 1 ? 'hide-text' : '' : 'hide-text')" v-if="!route.header">{{route.title}}</span>
                    <span class="hide-text header-menu" v-if="route.header">{{ route.title }}</span>
                    <b-badge v-if="route.badge" v-show="isVisible(route.badge)" :variant="route.badge.variant" class="mr-2" style="margin-left: 5px;">
                        {{$store.state.app[route.badge.state]}}
                        {{route.badge.text}}
                    </b-badge>
                    
                    <i class="ti ti-angle-down dd-arrow ml-auto hide-text" v-if="route.children"></i>
                </span>
            </router-link>

            <b-collapse :id="route.id"  v-if="route.children" :visible="(LayoutType == 'mini-sidebar'? (treeStage == 0 ? true : route.expand ): route.expand)">
                <ul class="nav flex-column sub-menu">
                    <template v-for="(children,i) in route.children" >
                        <menu-item :route="children" :key="`${children.id}_${i}`" :tree-stage="treeStage + 1"></menu-item>
                    </template>
                </ul>
            </b-collapse>

          </li>
    </div>
</template>
<script>
import { mapState } from "vuex";
import MenuItem from "./Menu";

export default {
    name: "MenuItem",
    components: {
        MenuItem
    },
    props: {
        route: {
            required: true
        },
        treeStage: {
            required: true
        }
    },
    methods: {
        isVisible: function (badge) {
            if (!badge.show)
                return true;

            switch (badge.show.expression) {
                case '>':
                    return (this.$store.state.app[badge.state] > badge.show.expected);
                default:
                    break;
            }
        },
        expand: function (route) {
            if (!route.expand == undefined)
                route.expand = true
            else
                route.expand = !route.expand
        },
        expandMouse(route, expand) {
            if (this.LayoutType == 'mini-sidebar')
                route.expand = expand
        },

    },
    computed: {
        ...mapState(["LayoutType"]),
    },
    watch: {
        LayoutType: {
            handler(newValue, oldValue) {
                if(oldValue== 'full-sidebar' && newValue== 'mini-sidebar')
                {
                    this.route.expand = false;
                }
            }
        }
    }
}
</script>
<style>
    
</style>